export const ERROR_MESSAGES = {
    INVALID_EMAIL: 'Invalid e-mail address',
    REQUIRED_EMAIL: 'E-mail address is a required field',
    DUPLICATE_EMAIL: 'E-mail already exists',
    FEDERATED_EMAIL: "This e-mail can't be used to Sign Up. Please, click this link bellow to continue.",
};

export const REGEXES = {
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
